module.exports = __webpack_public_path__ + "img/ease_logo.a9bcbbeb.png";